import { render } from "./source-code.vue?vue&type=template&id=17b4b1f4&scoped=true"
import script from "./source-code.vue?vue&type=script&lang=js"
export * from "./source-code.vue?vue&type=script&lang=js"

import "./source-code.vue?vue&type=style&index=0&id=17b4b1f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b4b1f4"]])

export default __exports__